import styled from 'styled-components';
import { mixins } from '../../design-system';
import { tokens } from 'design-tokens/warwick/tokens';

// TV-Optimized: No backdrop-filter, no box-shadow, simple layout
export const Container = styled.div`
  ${mixins.flexCenterVertical}
  > * + * {
    margin-inline-start: ${tokens.primitive.space[30]};
  }
`;

export const WeatherIcon = styled.div`
  ${mixins.flexCenterVertical}

  img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
`;

export const Temperature = styled.div`
  ${mixins.flexCenterVertical}
  line-height: 1;
`;

export const TemperatureValue = styled.span`
  font-family: ${tokens.primitive.typography.fontFamily.base};
  font-size: ${tokens.primitive.typography.fontSize[37]};
  font-weight: ${tokens.primitive.typography.fontWeight.regular};
  line-height: ${tokens.primitive.typography.lineHeight.tight};
  color: ${tokens.semantic.color.text.onLight};
`;

export const TimeDisplay = styled.div`
  ${mixins.textWeatherTime}
`;
